import { type ApiMessage } from '@app/types'
import axios from 'axios'

// Maps an axios error from POST /api/documents/upload to a user-facing notification.
// HTTP status codes come from Sugar's SugarApiException mappings (per MIQ-2117 iter-11):
// 422 = missing/invalid params or empty file, 413 = too large, 403 = cross-site auth,
// 404 = enrollment/parent application not found.
export const mapUploadError = (error: unknown): ApiMessage => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status
    const apiMessage = error.response?.data?.messages?.[0]?.message as string | undefined

    if (status === 422) {
      return { message: apiMessage ?? 'Please select a valid category and file.', type: 'error' }
    }
    if (status === 413) return { message: 'File is too large.', type: 'error' }
    if (status === 403) return { message: "You don't have access to this child.", type: 'error' }
    if (status === 404) return { message: "Could not find this child's record.", type: 'error' }

    return { message: apiMessage ?? 'Upload failed. Please try again.', type: 'error' }
  }

  if (error instanceof Error) return { message: error.message, type: 'error' }

  return { message: 'Upload failed. Please try again.', type: 'error' }
}
